import { Check, X } from "lucide-react";
import { evaluatePassword } from "../lib/passwordStrength";

export default function PasswordStrengthMeter({ password = "" }) {
  const { rules, score, label, color } = evaluatePassword(password);
  if (!password) return null;

  return (
    <div data-testid="password-strength-meter" className="mt-3">
      {/* Score bar */}
      <div className="flex gap-1.5" aria-hidden="true">
        {[0, 1, 2, 3].map((i) => (
          <div
            key={i}
            className="h-1.5 flex-1 rounded-full transition-colors duration-300"
            style={{ backgroundColor: i < score ? color : "#F1D9E3" }}
          />
        ))}
      </div>
      <div className="flex items-center justify-between mt-2">
        <span className="text-xs font-medium" style={{ color }}>
          {label}
        </span>
        <span className="text-xs text-brand-muted">{score}/4 met</span>
      </div>

      {/* Live requirements checklist */}
      <ul className="mt-3 space-y-1.5" aria-live="polite">
        {rules.map((r) => (
          <li
            key={r.id}
            className={`flex items-center gap-2 text-xs ${
              r.ok ? "text-green-700" : "text-brand-muted"
            }`}
            data-testid={`pwd-rule-${r.id}-${r.ok ? "ok" : "fail"}`}
          >
            <span
              className={`shrink-0 w-4 h-4 rounded-full flex items-center justify-center ${
                r.ok ? "bg-green-100" : "bg-brand-primary-light"
              }`}
            >
              {r.ok ? (
                <Check size={11} strokeWidth={3} className="text-green-700" />
              ) : (
                <X size={11} strokeWidth={2.5} className="text-brand-primary/60" />
              )}
            </span>
            {r.label}
          </li>
        ))}
      </ul>
    </div>
  );
}
